// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"df0b6235","726":"6b209c7b","785":"54fb6d51"}[chunkId] + ".chunk.js";
};